import Router from 'next/router';
import { UserPasswordApi } from '@api';
import { userPasswordTypes as actionTypes } from './types';

export const createUserPassword = (params) => (dispatch) => {
  dispatch({
    type: actionTypes.CREATE.LOADING,
  });

  const { redirectTo, ...data } = params;

  UserPasswordApi.create(data)
    .then(() => {
      dispatch({
        type: actionTypes.CREATE.SUCCESS,
        message: 'updated',
      });
      Router.push(redirectTo || '/advertisers/users/login');
    })
    .catch((error) => {
      dispatch({
        type: actionTypes.CREATE.FAILURE,
        message: error.statusText,
      });
    });
};
export const updateUserPassword = (params) => (dispatch) => {
  dispatch({
    type: actionTypes.UPDATE.LOADING,
  });

  UserPasswordApi.update(params)
    .then(() => {
      dispatch({
        type: actionTypes.UPDATE.SUCCESS,
        message: 'notify:passwordUpdate.success.updated',
      });
    })
    .catch(() => {
      dispatch({
        type: actionTypes.UPDATE.FAILURE,
        message: 'notify:passwordUpdate.error.unprocessableEntity',
      });
    });
};
